import { getMockPolicyDocuments } from '../MockData';
import { getPolicyDocumentsFromDAM } from '../API';

import {
  Group,
  SearchType,
  Document,
  DocumentDescription,
  GetPolicyDocumentsCallback,
} from '../../../models/policy-doc-search-types';

export const getPolicyDocuments = (
  returnMockData: boolean,
  searchType: SearchType,
  searchTerm: string,
  callBack: GetPolicyDocumentsCallback
) =>
  returnMockData
    ? getMockPolicyDocuments(searchType, searchTerm, callBack)
    : getPolicyDocumentsFromDAM(searchType, searchTerm, callBack);

export const getDocumentsCount = (groups: Group[]): number => {
  let $count = 0;

  for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
    const group = groups[groupIndex];
    const { subGroups } = group;

    if (subGroups) {
      for (let subGroupIndex = 0; subGroupIndex < subGroups.length; subGroupIndex++) {
        const subGroup = subGroups[subGroupIndex];
        const { policies } = subGroup;
        $count = policies ? $count + policies.length : $count;
      }
    }
  }

  return $count;
};

export const filterDocumentsByTitle = (groups: Group[], searchTerm: string): Group[] => {
  const termToFind = searchTerm.toLowerCase();

  const matchingPolicies: Document[] = [];

  for (let groupIndex = 0; groupIndex < groups.length; groupIndex++) {
    const group = groups[groupIndex];
    const { subGroups } = group;

    if (subGroups) {
      for (let subGroupIndex = 0; subGroupIndex < subGroups.length; subGroupIndex++) {
        const subGroup = subGroups[subGroupIndex];
        const { policies } = subGroup;

        if (policies) {
          for (let documentIndex = 0; documentIndex < policies.length; documentIndex++) {
            const document = policies[documentIndex];
            const { description } = document;

            if (description.toLowerCase().indexOf(termToFind) >= 0) {
              matchingPolicies.push(document);
            }
          }
        }
      }
    }
  }

  if (matchingPolicies.length > 0) {
    const $data = getGroupsFromDocuments(matchingPolicies);
    return $data;
  }

  return [];
};

export const getGroupsFromDocuments = (documents: Document[]): Group[] => {
  if (!documents || documents.length === 0) {
    return [];
  }

  documents = documents.sort((a, b) => a.description.localeCompare(b.description));

  const group: Group = {
    docGroup: '',
    subGroups: [
      {
        subHeaderDescription: '',
        policies: documents,
      },
    ],
  };

  return [group];
};

export const parseDocumentDescription = (description: string): DocumentDescription => {
  const documentDescription: DocumentDescription = { title: description, effectiveDate: '' };

  if (description) {
    const $lastIndex = description.lastIndexOf('(');

    if ($lastIndex > 0) {
      documentDescription.title = description.substring(0, $lastIndex).trim();
      const $dateString = description.substring($lastIndex).replace('(', '').replace(')', '').replace('&diams;', '');
      documentDescription.effectiveDate = new Date($dateString).toISOString().slice(0, 10);
    }
  }

  return documentDescription;
};

export const getAllAlphabets = (): string[] => {
  const alpha = Array.from(Array(26)).map((e, i) => i + 65 || e);
  const alphabet = alpha.map((x) => String.fromCharCode(x));
  return alphabet;
};

export const getDocumentGroupByDocGroup = (groups: Group[], docGroup: string): Group => {
  for (let index = 0; index < groups.length; index++) {
    const group = groups[index];

    if (group.docGroup === docGroup) {
      return group;
    }
  }

  const emptyGroup = { docGroup: '', subGroups: [] };

  return emptyGroup;
};
